// extracted by mini-css-extract-plugin
export default {"team-title":"team_team-title__ClfyN","main-title":"team_main-title__+-ENV","label-ct":"team_label-ct__dfjuW"};